import { BoldChipColors } from 'components/BoldChip';
import { TranslationKey } from 'modules/i18n';

export enum GeneralStatus {
  CLOSED = 'CLOSED',
  CONFIRMED = 'CONFIRMED',
  CORRECTED = 'CORRECTED',
  IN_REVIEW = 'IN_REVIEW',
  OPEN = 'OPEN',
  REPORTED = 'REPORTED'
}

export enum AssignmentStatus {
  UPCOMING = 'UPCOMING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED'
}

export enum AssignmentChangeStatus {
  APPLIED = 'APPLIED',
  NOT_APPLIED = 'NOT_APPLIED'
}

export enum GeolocationPermissionStatus {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt',
  UNAVAILABLE = 'unavailable'
}

export type StatusType =
  | GeneralStatus
  | AssignmentStatus
  | AssignmentChangeStatus
  | GeolocationPermissionStatus;

export interface StatusMap {
  color: BoldChipColors;
  label: TranslationKey | '';
}
